// src/config/apiConfig.js

export const Config = () => {
    return {
      APIKEY: "SykthemmeligAPIkeySomIngenKanGjettEllerKneppTakI",
    };
  };
  
  export default Config;
  